import { GameCssStyles } from '../GameCssStyles'
import { Box } from '@mui/material'
import StandardAboutGame from '../CommonLayout/StandardAboutGame'
import StandardForkContestRules from '../CommonLayout/StandardForkContestRules'
import PredictionAnchor from './PredictionAnchor'
import QuestionEditor from '../CommonLayout/QuestionEditor'

const PredictionBasedGame = ({ formGameData, showsList, setFormGameData, handleChange }) => {
    return (
        <Box sx={GameCssStyles.containerStyleColumnWithoutBorder_sx}>
            <StandardAboutGame formGameData={formGameData} handleChange={handleChange} />
            <PredictionAnchor formGameData={formGameData} showsList={showsList} handleChange={handleChange} />
            <QuestionEditor formGameData={formGameData} handleChange={handleChange} />
            <StandardForkContestRules formGameData={formGameData} setFormGameData={setFormGameData} handleChange={handleChange} />
        </Box>
    )
}

export default PredictionBasedGame
